import { queryOptions, useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const offersQueryOptions = queryOptions({
  queryKey: ['offers'],
  queryFn: async () => {
    const now = new Date().toISOString();
    const { data, error } = await supabase
      .from('offers')
      .select('*')
      .or(`start_at.is.null,start_at.lte.${now}`)
      .or(`end_at.is.null,end_at.gte.${now}`);

    if (error) throw error;
    return data || [];
  },
  staleTime: 10 * 60 * 1000, // Offers don't change frequently
  gcTime: 20 * 60 * 1000,
});

export const useOffers = () => useQuery(offersQueryOptions);
